// Version : 1.0.0
// Author : AGALYA
import CreditCheckActionType from './credit-check.types';

/** ***************** CREDIT CHECK MEMBER ADD START *********************** */
export const creditCheckMemberAddStart = (creditCheckCredentials: any) => ({
	type: CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_START,
	payload: creditCheckCredentials,
});

export const creditCheckMemberAddSuccess = (creditCheckSuccess: any) => ({
	type: CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_SUCCESS,
	payload: creditCheckSuccess,
});

export const creditCheckMemberAddFailure = (creditCheckFailure: unknown) => ({
	type: CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_FAILURE,
	payload: creditCheckFailure,
});

export const creditCheckMemberAddResponseResetStart = () => ({
	type: CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_RESPONSE_REST_START,
});

export const creditCheckMemberAddUserResponseChanged = () => ({
	type: CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_RESPONSE_CHANGED,
});
/** ***************** CREDIT CHECK MEMBER ADD END *********************** */

/** ***************** CREDIT CHECK CALL START *********************** */
export const creditCheckCallStart = (creditCheckCredentials: any) => ({
	type: CreditCheckActionType.CREDIT_CHECK_CALL_START,
	payload: creditCheckCredentials,
});

export const creditCheckCallSuccess = (creditCheckSuccess: any) => ({
	type: CreditCheckActionType.CREDIT_CHECK_CALL_SUCCESS,
	payload: creditCheckSuccess,
});

export const creditCheckCallFailure = (creditCheckFailure: unknown) => ({
	type: CreditCheckActionType.CREDIT_CHECK_CALL_FAILURE,
	payload: creditCheckFailure,
});

export const creditCheckCallResponseResetStart = () => ({
	type: CreditCheckActionType.CREDIT_CHECK_CALL_RESPONSE_REST_START,
});

export const creditCheckCallUserResponseChanged = () => ({
	type: CreditCheckActionType.CREDIT_CHECK_CALL_RESPONSE_CHANGED,
});
/** ***************** CREDIT CHECK CALL END *********************** */

/** ***************** VERIFY MEMBER DETAILS START *********************** */
export const verifyMemberStart = (memberCredentials: any) => ({
	type: CreditCheckActionType.VERIFY_MEMBER_START,
	payload: memberCredentials,
});

export const verifyMemberSuccess = (verifiedSuccess: any) => ({
	type: CreditCheckActionType.VERIFY_MEMBER_SUCCESS,
	payload: verifiedSuccess,
});

export const verifyMemberFailure = (verifiedFailure: unknown) => ({
	type: CreditCheckActionType.VERIFY_MEMBER_FAILURE,
	payload: verifiedFailure,
});

export const verifyMemberResponseResetStart = () => ({
	type: CreditCheckActionType.VERIFY_MEMBER_RESPONSE_RESET_START,
});

export const verifyMemberUserResponseChanged = () => ({
	type: CreditCheckActionType.VERIFY_MEMBER_RESPONSE_CHANGED,
});
/** ***************** VERIFY MEMBER DETAILS END *********************** */

/** ***************** SEND VERIFICATION OTP START *********************** */
export const sendVerificationOtpStart = (memberCredentials: any) => ({
	type: CreditCheckActionType.SEND_VERIFICATION_OTP_START,
	payload: memberCredentials,
});

export const sendVerificationOtpSuccess = (verifiedSuccess: any) => ({
	type: CreditCheckActionType.SEND_VERIFICATION_OTP_SUCCESS,
	payload: verifiedSuccess,
});

export const sendVerificationOtpFailure = (verifiedFailure: unknown) => ({
	type: CreditCheckActionType.SEND_VERIFICATION_OTP_FAILURE,
	payload: verifiedFailure,
});

export const sendVerificationOtpResponseResetStart = () => ({
	type: CreditCheckActionType.SEND_VERIFICATION_OTP_RESPONSE_RESET_START,
});

export const sendVerificationOtpResponseChanged = () => ({
	type: CreditCheckActionType.SEND_VERIFICATION_OTP_RESPONSE_CHANGED,
});
/** ***************** SEND VERIFICATION OTP END *********************** */

/** ***************** VERIFY AADHAAR OTP DETAILS START *********************** */
export const verifyCreditCheckAadharOtpStart = (DetailsCredentials: any) => ({
	type: CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyCreditCheckAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyCreditCheckAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyCreditCheckAadharOtpResponseResetStart = () => ({
	type: CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyCreditCheckAadharOtpResponseChanged = () => ({
	type: CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** VERIFY AADHAAR OTP DETAILS END *********************** */

/** ***************** VERIFY VALIDATE AADHAAR OTP DETAILS START *********************** */
export const verifyValidateCreditCheckAadharOtpStart = (DetailsCredentials: any) => ({
	type: CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyValidateCreditCheckAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyValidateCreditCheckAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyValidateCreditCheckAadharOtpResponseResetStart = () => ({
	type: CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyValidateCreditCheckAadharOtpResponseChanged = () => ({
	type: CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** VERIFY VALIDATE AADHAAR OTP DETAILS END *********************** */

/** ***************** RECHECK MEMBER DETAILS FOR CRIF START *********************** */
export const recheckMemberDetailsStart = (DetailsCredentials: any) => ({
	type: CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_START,
	payload: DetailsCredentials,
});

export const recheckMemberDetailsSuccess = (DetailsSuccess: any) => ({
	type: CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_SUCCESS,
	payload: DetailsSuccess,
});

export const recheckMemberDetailsFailure = (DetailsFailure: unknown) => ({
	type: CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_FAILURE,
	payload: DetailsFailure,
});

export const recheckMemberDetailsResponseResetStart = () => ({
	type: CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_RESPONSE_RESET_START,
});

export const recheckMemberDetailsResponseChanged = () => ({
	type: CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_RESPONSE_CHANGED,
});
/** ***************** RECHECK MEMBER DETAILS FOR CRIF END *********************** */

/** ***************** EQUIFAX CHECK CALL START *********************** */
export const equifaxCheckCallStart = (creditCheckCredentials: any) => ({
	type: CreditCheckActionType.EQUIFAX_CHECK_CALL_START,
	payload: creditCheckCredentials,
});

export const equifaxCheckCallSuccess = (creditCheckSuccess: any) => ({
	type: CreditCheckActionType.EQUIFAX_CHECK_CALL_SUCCESS,
	payload: creditCheckSuccess,
});

export const equifaxCheckCallFailure = (creditCheckFailure: unknown) => ({
	type: CreditCheckActionType.EQUIFAX_CHECK_CALL_FAILURE,
	payload: creditCheckFailure,
});

export const equifaxCheckCallResponseResetStart = () => ({
	type: CreditCheckActionType.EQUIFAX_CHECK_CALL_RESPONSE_REST_START,
});

export const equifaxCheckCallUserResponseChanged = () => ({
	type: CreditCheckActionType.EQUIFAX_CHECK_CALL_RESPONSE_CHANGED,
});
/** ***************** EQUIFAX CHECK CALL END *********************** */
